import { useParams } from 'react-router-dom'
import { Section } from '../../components/Section'
import { PageContent } from '../../components/PageContent'

export function Case() {
 const { slug } = useParams()

 return (
  <Section id="case" title="Case" className="py-24">
   <PageContent slug={slug} />
  </Section>
 )
}
